import React, { useState } from "react";
import "./QuoteBox.css";

const QuoteBox = () => {
  const [form, setForm] = useState({
    workType: "",
    depth: "",
    width: "",
    floor: "",
    area: "",
    facing: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const sendToWhatsApp = () => {
    const phoneNumber = "919752536668"; // apna WhatsApp number yaha daalein
    const message = `📐 New Quote Request:
- Work Type: ${form.workType}
- Depth: ${form.depth}
- Width: ${form.width}
- Floor: ${form.floor}
- Area: ${form.area}
- Facing: ${form.facing}`;

    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(url, "_blank");
  };

  return (
    <div className="quote-box">
      <h2>Get Your Quote Now</h2>

      {/* Work Type */}
      <div className="work-types">
        <label>
          <input
            type="radio"
            name="workType"
            value="2D Layout Plan"
            onChange={handleChange}
          />
          2D Layout
        </label>
        <label>
          <input
            type="radio"
            name="workType"
            value="3D Front Elevation"
            onChange={handleChange}
          />
          3D Elevation
        </label>
        <label>
          <input
            type="radio"
            name="workType"
            value="Structural Drawing"
            onChange={handleChange}
          />
          Structural
        </label>
        <label>
          <input
            type="radio"
            name="workType"
            value="Presentation Plan"
            onChange={handleChange}
          />
          Presentation
        </label>
      </div>

      {/* Inputs */}
      <div className="form-fields">
        {/* Row 1: Depth + Width */}
        <div className="row">
          <input
            type="text"
            placeholder="Depth (ft)"
            name="depth"
            value={form.depth}
            onChange={handleChange}
          />
          <input
            type="text"
            placeholder="Width (ft)"
            name="width"
            value={form.width}
            onChange={handleChange}
          />
        </div>

        {/* Row 2: Floor + Area */}
        <div className="row">
          <input
            type="text"
            placeholder="Floor"
            name="floor"
            value={form.floor}
            onChange={handleChange}
          />
          <input
            type="text"
            placeholder="Building Area (sq.ft)"
            name="area"
            value={form.area}
            onChange={handleChange}
          />
        </div>

        {/* Row 3: Facing (full width) */}
        <select name="facing" value={form.facing} onChange={handleChange}>
          <option value="">Select Facing</option>
          <option value="North">North</option>
          <option value="East">East</option>
          <option value="West">West</option>
          <option value="South">South</option>
          <option value="North-East">North-East</option>
          <option value="North-West">North-West</option>
          <option value="South-East">South-East</option>
          <option value="South-West">South-West</option>
        </select>
      </div>

      <button className="quote-btn" onClick={sendToWhatsApp}>
        Get Quote on WhatsApp
      </button>
    </div>
  );
};

export default QuoteBox;